import Create from './Create'
import List from './List'
import EmailHistory from './EmailHistory'

const MailerModules = {
    List,
    Create,
    EmailHistory,
}
export default MailerModules
